<section class="mainTopBanner section-pd">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="topBannerWrapper">
                    <div class="top-banner-left">
                        <h1 class="trinka-sub-title">高級方案專屬</h1>
                        <h2>Trinka Microsoft Word 外掛程式</h2>
                        <p>Trinka Word 擴充工具讓有效寫作前所未有地簡單！您只需在熟悉的 Word 介面中寫作，Trinka 就會自動即時檢查並提供修正建議。</p>
                            <div class="wordPluginCTA btn-group" id="MSWindowDownloadButton">
                                <div id="windowInfo64bit" [innerHTML]="downloadLink"></div>
                                <!-- <i class="">Beta</i> -->
                            </div>
                            <span id="MSWindowTextContent">*支援 Windows系統Word 2010以上版本</span>
                    </div>
                    <div class="top-banner-right">
                        <img src="/assets/images/word-add-in-banner.svg" width="551" height="521" alt="ms word" priority />
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="howItWorks section-pd list-wrapper-style-2">
    <div class="trinka_container container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="list-wrapper-image">
                    <a href="" data-toggle="modal" data-target="#youtubeModalPopup" id="VewiVideoSection">
                        <img src="/assets/images/yt-thumbnail/microsoft-wordThumbnails.webp" width="551" height="310" alt="ms word" class="img-fluid eposter-img">
                    </a>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="list-wrapper-content-2">
                    <div class="trinka-title mb-0">
                        <h2>觀看教學</h2>
                        <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                        <p>還不清楚怎麼安裝 Trinka 的 Word 外掛程式，或想知道怎麼用它來修正內容嗎？</p>
                        <p>立即觀看操作教學影片，了解如何在Windows作業系統上使用Word的Trinka外掛程式</p>
                        <p class="mb-0">還有其他問題嗎？歡迎瀏覽我們的常<a (click)="scroll(target)" class="text-link">見問答</a>.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="cloud_key_features section-pd list-wrapper-style-2">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title mb-0 text-center">
                    <h2>Trinka Microsoft Word外掛程式主要功能</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>Trinka for MS Word 是專為您熟悉的 Word 環境打造的寫作助手，讓您在撰寫過程中即時收到專業文法修正與風格建議，所有更動皆自動檢查，不遺漏任何細節！</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <img src="/assets/images/grammar-checker-icon.svg" width="40" height="40" alt="Grammar Checker" />
                    <h3>即時英文文法檢查</h3>
                    <p>直接在 Word 中提供高級文法與用字建議，提升內容專業度。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <img src="/assets/images/multilingual-icon.png" width="40" height="40" alt="Grammar Checker" />
                    <h3>多語系文法檢查（支援西班牙文）</h3>
                    <p>自動偵測語言，針對西班牙文內容提供文法修正，讓多語寫作也更精準。

                    </p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <img src="/assets/images/error-highlight-icon.svg" width="40" height="40" alt="Interactive Error Highlighting">
                    <h3>互動式錯誤提示</h3>
                    <p>文件中的文法錯誤會直接在頁面上清楚標示，相關建議則會顯示在右側專用面板中，方便您輕鬆查看。
                    </p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 dflex">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <img src="/assets/images/style_guide_icon.svg" width="40" height="40" alt="Style Guide Preferences">
                    <h3>寫作風格指南偏好設定</h3>
                    <p>根據流行的學術寫作風格指南 (APA、AMA、AGU、ACS、IEEE)，自訂您稿件的文法和詞彙選擇。</p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 dflex">
                <div class="commingSoonTag list-wrapper-content-2 list-style-cards bt-1">
                    <span class="badge">無限制標準檢查與抄襲比對（高級 Plus 專屬）</span>
                    <img src="/assets/images/ppc_icon.png" width="40" height="40" alt="ppc">
                    <h3>抄襲檢查</h3>
                    <p>透過 Trinka Credit 執行抄襲檢查，比對超過 8200 萬筆付費出版內容與網路資料。</p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 dflex">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <img src="/assets/images/paraphraser-icon.svg" width="40" height="40" alt="Paraphraser">
                    <h3>AI 智慧文章改寫助手<br class="d-lg-block d-none"/>&nbsp; <div class="beta-badge">New</div></h3>
                    <p>寫作同時即時改寫句子，使內容更清晰、自然且語意一致。</p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 dflex">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <img src="/assets/images/autoFileEdit_icon.svg" width="40" height="40" alt="auto file edit">
                    <h3>自動校對文件</h3>
                    <p>一鍵完成自動編修與品質評分，並保留軌跡修訂，快速產出可交稿的文件版本。</p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 dflex">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <img src="/assets/images/subjectAreaAndDocumentType.svg" alt="subject">
                    <h3>依主題與文件類型給建議</h3>
                    <p>可自訂學科領域與文件類型，讓修正建議更精準符合您的寫作需求。</p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 dflex">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <img src="/assets/images/AddtoDictionary.svg" alt="Mac Word | Add to Dictionary" />
                    <h3>添加到個人詞典</h3>
                    <p>可自訂專業詞彙加入「我的詞典」，避免未來寫作中被標示為拼字錯誤。</p>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="faqQuestionAnwser section-pd pt-0" #target>
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title text-center">
                    <h2>常見問答</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="faqQuestionsList">
            <div class="accordion" id="faq">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        如何在Microsoft Word 中 安裝 Trinka 外掛程式？
                                    </a>
                                </div>

                                <div id="QuestionOneContent" class="collapse" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>
                                            前往 Trinka Word 外掛程式頁面，點選 <span [innerHTML]="downloadLink1">「立即下載」</span>。下載完成後執行安裝檔，依指示完成安裝流程。安裝完成後，開啟 Microsoft Word，您會在上方功能區看到「Trinka」分頁，點選並使用您的 Trinka 帳號登入，即可開始使用。
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true" aria-controls="QuestionTwoContent">
                                        如何啟用 Trinka 文法檢查功能？
                                    </a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>
                                            安裝完 Trinka 外掛程式並登入後，在 Word 的功能區中點選「Trinka」分頁，再按下「啟動」即可開啟即時文法檢查。
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true" aria-controls="QuestionThreeContent">
                                        安裝系統需求？
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>適用版本：Windows 系統上的 Microsoft Word 2010 或更高版本。</p>
                                        <p>安裝空間需求：建議至少 8GB 可用硬碟空間</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true" aria-controls="QuestionFourContent">
                                        我可以在 Mac 上使用 Trinka Word 外掛程式嗎？
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>
                                            可以。請參考下方連結安裝 Mac 專用版本：<a href="https://appsource.microsoft.com/en-us/product/office/WA200004694?tab=Overview" target="_blank" class="text-link">
                                                https://appsource.microsoft.com/en-us/product/office/WA200004694?tab=Overview
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFive">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFiveContent" aria-expanded="true" aria-controls="QuestionFiveContent">
                                        Trinka 是否會即時檢查拼字與文法？
                                    </a>
                                </div>

                                <div id="QuestionFiveContent" class="collapse" aria-labelledby="QuestionFive" data-parent="#faq">
                                    <div class="card-body">
                                        <p>是的，Trinka Word 外掛程式會即時檢查並在您修改文字後重新提供建議。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionSix">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionSixContent" aria-expanded="true" aria-controls="QuestionSixContent">
                                        如何接受或拒絕 Trinka 的建議？
                                    </a>
                                </div>

                                <div id="QuestionSixContent" class="collapse" aria-labelledby="QuestionSix" data-parent="#faq">
                                    <div class="card-body">
                                        <p>只需點選建議字詞即可接受修正。如需拒絕，點選「倒讚」圖示。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionSeven">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionSevenContent" aria-expanded="true" aria-controls="QuestionSevenContent">
                                        可以切換美式與英式英文嗎？
                                    </a>
                                </div>

                                <div id="QuestionSevenContent" class="collapse" aria-labelledby="QuestionSeven" data-parent="#faq">
                                    <div class="card-body">
                                        <p>可以。於功能區的「語言與設定」選單中選擇美式 (US) 或英式 (UK) 英文即可。
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionEightSection">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionEightSectionContent" aria-expanded="true" aria-controls="QuestionEightSectionContent">
                                        可以選擇符合的寫作風格指南嗎？
                                    </a>
                                </div>

                                <div id="QuestionEightSectionContent" class="collapse" aria-labelledby="QuestionEightSection" data-parent="#faq">
                                    <div class="card-body">
                                        <p>可以。從「語言與設定」選單中選擇 APA、AMA、IEEE 等主流格式指南。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionEight">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionEightContent" aria-expanded="true" aria-controls="QuestionEightContent">
                                        如果我沒有使用 Word，能否在線上平台使用 Trinka？
                                    </a>
                                </div>

                                <div id="QuestionEightContent" class="collapse" aria-labelledby="QuestionEight" data-parent="#faq">
                                    <div class="card-body">
                                        <p>
                                            可以。Trinka 提供瀏覽器外掛程式，支援 Chrome、Firefox 與 Edge，可在 Medium 等網站上直接使用。點此下載瀏覽器外掛程式
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionTen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTenContent" aria-expanded="true" aria-controls="QuestionTenContent">
                                        安裝成功卻找不到 Trinka 外掛程式怎麼辦？
                                    </a>
                                </div>

                                <div id="QuestionTenContent" class="collapse" aria-labelledby="QuestionTen" data-parent="#faq">
                                    <div class="card-body">
                                        <p>可能是系統或公司安全設定導致外掛程式被停用。請依下列步驟手動啟用： 開啟 Word → 檔案 → 選項 → 增益集</p>
                                        <p>下拉選單選擇「COM 增益集」→ 管理 → 啟用 Trinka</p> 
                                        <p><a href="https://youtu.be/RDrzQOBNAsk" target="_blank" class="text-link">或觀看教學影片了解操作流程。</a>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="Question11">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#Question11Content" aria-expanded="true" aria-controls="Question11Content">
                                        Trinka 外掛程式無法偵測到寫作錯誤怎麼辦？
                                    </a>
                                </div>

                                <div id="Question11Content" class="collapse" aria-labelledby="Question11" data-parent="#faq">
                                    <div class="card-body">
                                        <ul>
                                            <li>您可以嘗試以下幾個步驟來解決問題：
                                                確保電腦已連上網路</li>
                                            <li>確認外掛程式未被系統或安全設定停用</li>
                                            <li>嘗試從控制台解除安裝後重新安裝</li>
                                            <li>
                                                確認螢幕縮放設定為 100% 或 125%
                                            </li>
                                            <li>若使用多螢幕，請將 Word 移到主螢幕</li>
                                            <li>問題仍無法解決？請聯絡支援：<a href="mailto:support@trinka.ai" class="text-link">support&#64;trinka.ai</a>，我們的團隊將協助您處理。</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<section class="ListLiners hideWordPlugin">
    <app-trinka-in-other-apps></app-trinka-in-other-apps>
</section>

<div class="modal" id="youtubeModalPopup">
    <div class="modal-dialog modal-dialog-centered modal-lg">
       <div class="modal-content">
          <div class="modal-body no-padding">
             <button type="button" class="btn-close" data-dismiss="modal" (click)="stopAllVideos()"></button>
             <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/cTo16u94rxc"
                title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen></iframe>
          </div>
       </div>
    </div>
</div>